import React, { useState } from "react";
import GenericModal from "./genericModal";
import { Col, Row, Typography } from "antd";
import { backendDeleteWithoutRefresh } from "../../helpers/callBackend";
import LoadingButton from '@mui/lab/LoadingButton';

const { Text } = Typography;

const GenericDeleteModal = (props) => {
    const [visible, setVisible] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const handleDelete = () => {
        if (props.URL === undefined || props.deleteParams === undefined)
            return props.handleDeleteSuccess();
        setSubmitting(true);
        if (props.handleRequestStart) {
            props.handleRequestStart();
        }
        backendDeleteWithoutRefresh(props.URL, props.deleteParams)
            .then((res) => {
                if (res && res.status === 200) {
                    props.handleDeleteSuccess();
                } else {
                    props.handleDeleteFailure();
                }
                setVisible(false);
                setSubmitting(false);
            })
    };

    const modalBody = (
        <div>
            <Col>
                <Row><Text>{props.description}</Text></Row>
                {props.extra && (
                    <Row><Text>{props.extra}</Text></Row>
                )}
                <Row style={{ marginTop: '20px' }}>
                    <LoadingButton
                        style={{ margin: 'auto' }}
                        loading={submitting}
                        onClick={handleDelete}
                        loadingPosition="start"
                        disableElevation fullWidth size="small" type="submit" variant="outlined" color="error"
                        sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
                    > Delete </LoadingButton>
                </Row>
            </Col>
        </div>
    );

    return (
        <GenericModal
            button={<Text style={{ color: 'red' }}> Delete </Text>}
            size="md"
            modalTitle={props.title}
            visible={visible}
            showModal={() => setVisible(true)}
            handleCancelModal={() => setVisible(false)}
            modalBody={modalBody}
        />
    );
}

export default GenericDeleteModal;